import axios from 'axios';
import {
  EDITOR_LOAD_PAGES_BEGIN,
  EDITOR_LOAD_PAGES_DISMISS_ERROR,
  EDITOR_LOAD_PAGES_FAILURE,
  EDITOR_LOAD_PAGES_SUCCESS,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadPages(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_LOAD_PAGES_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/pages/${projectId}/project/min`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EDITOR_LOAD_PAGES_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EDITOR_LOAD_PAGES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadPagesError() {
  return {
    type: EDITOR_LOAD_PAGES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_LOAD_PAGES_BEGIN:
      return {
        ...state,
        loadPagesPending: true,
        loadPagesError: null,
      };

    case EDITOR_LOAD_PAGES_SUCCESS:
      return {
        ...state,
        loadPagesPending: false,
        loadPagesError: null,
        pages: action.data,
        showBuilderCanvasLoader: !state.showBuilderCanvasLoader,
      };

    case EDITOR_LOAD_PAGES_FAILURE:
      return {
        ...state,
        loadPagesPending: false,
        loadPagesError: action.data.error,
      };

    case EDITOR_LOAD_PAGES_DISMISS_ERROR:
      return {
        ...state,
        loadPagesError: null,
      };

    default:
      return state;
  }
}
